

import { useState } from "react";
import Config from "../../../Config";
import Free from "./Free";
import Layette from "./Layette";
import Book from "./Book";
import AllHour from "./AllHour";
import Persons from "./Persons";

 

//import Wall from "../../news/Wall"
 




function MyKidView(props)
{

 
    const [refreshView, setRefreshView] = useState(props.userData.refreshView);


 

    if(refreshView != props.userData.refreshView)
    {
        setRefreshView( props.userData.refreshView);  
    }


    var tab1 = " m_item ";
    var tab2 = " m_item ";
    var tab3 = " m_item ";
    var tab4 = " m_item ";
    var tab5 = " m_item ";
 

    if(props.mainView.viewSelected == "free") tab1 = tab1 + " selected";
    if(props.mainView.viewSelected == "layette") tab2 = tab2 + " selected";
    if(props.mainView.viewSelected == "book") tab3 = tab3 + " selected";
    if(props.mainView.viewSelected == "hours") tab4 = tab4 + " selected";
    if(props.mainView.viewSelected == "pickup") tab5 = tab5 + " selected";
 

    var subMenu = <div className="submenu">
            <div className={tab1} module="mykid" view="free" id="" onClick={props.mainView.quickGo} > { props.userData.dic.mFree} </div>       
            <div className={tab2} module="mykid" view="layette" id="" onClick={props.mainView.quickGo} >{ props.userData.dic.mThing}</div>       
            <div className={tab3} module="mykid" view="book" id="" onClick={props.mainView.quickGo} > { props.userData.dic.mBook} </div>       
            <div className={tab4} module="mykid" view="hours" id="" onClick={props.mainView.quickGo} > { props.userData.dic.mHour} </div>       
            <div className={tab5} module="mykid" view="pickup" id="" onClick={props.mainView.quickGo} > { props.userData.dic.mx_pickup} </div>       
    </div>
 
 

    if(props.mainView.viewSelected == 'free')
    {
        document.title = props.userData.dic.forParents + " / "  + props.userData.dic.mFree; 

        return (
            <div className="econtent ">                           
           
                   {subMenu} 
                    <Free  userData={props.userData}  mainView={props.mainView}  />                  
             </div>
        )
    }



    if(props.mainView.viewSelected == 'layette')
        {
            document.title = props.userData.dic.forParents + " / "  + props.userData.dic.mThing; 
    
            return (
                <div className="econtent ">                           
               
                       {subMenu} 
                        <Layette  userData={props.userData}  mainView={props.mainView}  />                  
                 </div>
            )
        }
    

        if(props.mainView.viewSelected == 'book')
            {
                document.title  = props.userData.dic.forParents  + " / "  + props.userData.dic.mBook ; 
        
                return (
                    <div className="econtent ">                           
                   
                           {subMenu} 
                            <Book  userData={props.userData}  mainView={props.mainView}  />                  
                     </div>
                )
            }
        
 

            if(props.mainView.viewSelected == 'hours')
                {
                    document.title  = props.userData.dic.forParents  + " / "  + props.userData.dic.mHour ; 
            
                    return (
                        <div className="econtent ">                           
                       
                               {subMenu} 
                               <AllHour  userData={props.userData}  mainView={props.mainView}  />                                                 
                         </div>
                    )
                }
            
     
                if(props.mainView.viewSelected == 'pickup')
                    {
                        document.title  = props.userData.dic.forParents  + " / "  + props.userData.dic.mx_pickup ; 
                
                        return (
                            <div className="econtent ">                           
                           
                                   {subMenu} 
                                   <Persons  userData={props.userData}  mainView={props.mainView}  />                                                 
                             </div>
                        )
                    }
 
                
                

    return (
        <div className="econtent ">
             {props.mainView.viewSelected}
        </div>
    );
}

export default MyKidView ;